import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/tunjangankinerjaService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import ReactTimeAgo from 'react-time-ago'
import moment from "moment"

import IndexBloc from "../Blocs/IndexBlock"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }
    
    source
    historyTable = 'historyRekapKetidakhadiranTableActive'
    defaultOrder = 'employee_full_name'
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            syncUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: false,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.syncData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    handleSync = () => {
        this.setState({
            confirm: true
        })
    }

    syncData  = async () => {
        let additionalFilter = this.props.additionalFilter;
        
        await this.indexBloc.fetchSync({ 
            uuid: this.state.syncUuid,
            ...additionalFilter
        })
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    exportKetidakhadiranExcel = () =>{
        let additionalFilter = this.props.additionalFilter;
        this.indexBloc.fetchPresensiKetidakhadiranExport({
            //uuid: this.state.uuid,
            ...additionalFilter
        });
    }

    componentDidMount() {
        // this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.syncChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        // this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.dataTableBloc.inactiveChannel.unsubscribe()
    }

    columns = [
        {
            key: "presensi_summary_employee_nip",
            text: "NIP",
            className: "presensi_summary_employee_nip",
            sortable: true,
            width: '80',
            cell : record => {
                return (
                  <>
                    {record.presensi_summary_employee_nip}
                    {/* <div>{record.employee_full_name}</div> */}
                  </>
                )
            }
        },
        {
            key: "employee_full_name",
            text: "Nama",
            className: "employee_full_name",
            sortable: true,
            width: '80',
            cell : record => {
                return (
                  <>
                    {record.employee_full_name}
                    {/* <div>{record.employee_full_name}</div> */}
                  </>
                )
            }
        },
        {
            key: "employee_current_rank_group_room",
            text: "",
            className: "employee_current_rank_group_room",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Gol <br />
                    Ruang
                  </div>
                )
              },
            cell : record => {
                return record.employee_current_rank_group_room;
            }
        },
        {
            key: "presensi_summary_late",
            text: "",
            className: "presensi_summary_late",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Akumulasi <br />
                    Terlambat
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_late;
            }
        },
        {
            key: "presensi_summary_akumulasi_pulang_cepat",
            text: "",
            className: "presensi_summary_akumulasi_pulang_cepat",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Akumulasi Pulang <br />
                    Awal
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_akumulasi_pulang_cepat;
            }
        },
        {
            key: "presensi_summary_akumulasi_single_finger",
            text: "",
            className: "presensi_summary_akumulasi_single_finger",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Akumulasi Single <br />
                    Finger
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_akumulasi_single_finger;
            }
        },
        {
            key: "presensi_summary_akumulasi_ketidakhadiran",
            text: "",
            className: "presensi_summary_akumulasi_ketidakhadiran",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Akumulasi <br />
                    Ketidakhadiran
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_akumulasi_ketidakhadiran;
            }
        },
        {
            key: "total_akumulasi",
            text: "",
            className: "total_akumulasi",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Total <br />
                    Akumulasi
                  </div>
                )
              },
            cell : record => {
                return record.total_akumulasi;
            }
        },
        
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                // const thisId = record.presensi_summary_id
                const status = record.presensi_summary_status
                var uuiddate = btoa(record.presensi_summary_uuid+'/'+record.period_start+'/'+record.period_end)
                const thisId = record.no;
                var is_danger = record.is_danger;
                return (
                    <Fragment>
                        {/* <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.presensi_summary_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Lihat</Tooltip>
                        </span> */}
                        {
                            is_danger > 0 ? (
                                <>
                                    <span>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            id={"detail-" + thisId}
                                            onClick={() => {
                                                this.setState({
                                                    detailUuid: uuiddate
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-file-search-alt"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["detail" + thisId] : !this.state["detail" + thisId]
                                                })
                                            }}
                                        >Lihat</Tooltip>
                                    </span>
                                </>
                            ) :(
                                <>
                                    <span>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            id={"detail-" + thisId}
                                            onClick={() => {
                                                this.setState({
                                                    detailUuid: uuiddate
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-file-search-alt"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["detail" + thisId] : !this.state["detail" + thisId]
                                                })
                                            }}
                                        >Lihat</Tooltip>
                                    </span>
                                </>
                            )
                        } 
                        
                        {/* {
                            status == 0 &&
                            <span>
                                <button
                                    className="btn btn-success btn-sm"
                                    id={"sync-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            syncUuid: record.presensi_summary_uuid
                                        })
                                        this.handleSync()
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-refresh"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["sync" + thisId]} target={"sync-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["sync" + thisId] : !this.state["sync" + thisId]
                                        })
                                    }}
                                >Sinkronisasi</Tooltip>
                            </span>
                        } */}
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan melakukan sinkronisasi data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/rekap_ketidakhadiran.html?detail&uuid=" + this.state.detailUuid}/>
                : null }
                {/* { this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?update&uuid=" + this.state.updateUuid}/>
                : null } */}
            </>
        )
    }

}

export default TableActiveComponent